import { render, staticRenderFns } from "./StyleFlow.vue?vue&type=template&id=22d3a438&scoped=true"
import script from "./StyleFlow.vue?vue&type=script&lang=js"
export * from "./StyleFlow.vue?vue&type=script&lang=js"
import style0 from "./StyleFlow.vue?vue&type=style&index=0&id=22d3a438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d3a438",
  null
  
)

export default component.exports